import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.placeholderHtml = this.contentTarget.innerHTML
    this.oneTimePlay = false
    this.boundConsentChange = this.consentChanged.bind(this)
    this.boundBeforeCache = this.prepareForCache.bind(this)

    window.addEventListener("TruendoCookieControl", this.boundConsentChange)
    document.addEventListener("turbo:before-cache", this.boundBeforeCache)

    // Wait until the adapter's action listener has connected.
    queueMicrotask(() => {
      if (this.element.isConnected && this.socialContentAllowed()) this.allow()
    })
  }

  disconnect() {
    window.removeEventListener("TruendoCookieControl", this.boundConsentChange)
    document.removeEventListener("turbo:before-cache", this.boundBeforeCache)
    this.oneTimePlay = false
  }

  play() {
    this.oneTimePlay = true
    this.allow()
  }

  consentChanged(event) {
    if (event.detail?.social_content === true) {
      this.allow()
    } else if (event.detail?.social_content === false) {
      this.removeContent()
    }
  }

  prepareForCache() {
    this.removeContent()
  }

  socialContentAllowed() {
    return window.Truendo?.cookieSettings?.social_content === true
  }

  allow() {
    this.dispatch("allow", { detail: { content: this.contentTarget, oneTime: this.oneTimePlay } })
    this.oneTimePlay = false
  }

  removeContent() {
    this.oneTimePlay = false
    this.contentTarget.innerHTML = this.placeholderHtml
  }
}
